import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./assets/pages/Home/Home";
import NovoAmistoso from "./assets/pages/NovoAmistoso/NovoAmistoso";
import IncluirJogadores from "./assets/pages/NovoAmistoso/IncluirJogadores";
import PreJogo from "./assets/pages/NovoAmistoso/PreJogo";
import JogoEmAndamento from "./assets/pages/JogoEmAndamento/JogoEmAndamento";
import RelatorioFinal from "./assets/pages/RelatorioFinal/RelatorioFinal";
import Login from "./assets/pages/Auth/Login";
import Register from "./assets/pages/Auth/Register";
import ProfileSettings from "./assets/pages/Profile/ProfileSettings";
import ProfileEdit from "./assets/pages/Profile/ProfileEdit";
import Friends from "./assets/pages/Friends/Friends";
import Turmas from "./assets/pages/Turmas/Turmas";
import CreateTurma from "./assets/pages/Turmas/CreateTurma";
import TurmaDetalhe from "./assets/pages/Turmas/TurmaDetalhe";
import TurmaConvites from "./assets/pages/Turmas/TurmaConvites";
import TurmaInviteLink from "./assets/pages/Turmas/TurmaInviteLink";
import TurmaNovoJogo from "./assets/pages/Turmas/TurmaNovoJogo";
import TurmaSettings from "./assets/pages/Turmas/TurmaSettings";
import TurmaRelatorio from "./assets/pages/Turmas/TurmaRelatorio";
import TurmaEstatisticas from "./assets/pages/Turmas/TurmaEstatisticas";
import ProtectedRoute from "./routes/ProtectedRoute";
import "./App.css";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/novo-amistoso" element={<NovoAmistoso />} />
      <Route
        path="/novo-amistoso/incluir-jogadores"
        element={<IncluirJogadores />}
      />
      <Route path="/novo-amistoso/pre-jogo" element={<PreJogo />} />
      <Route
        path="/novo-amistoso/jogo-em-andamento"
        element={<JogoEmAndamento />}
      />
      <Route path="/relatorio-final" element={<RelatorioFinal />} />
      <Route path="/login" element={<Login />} />
      <Route path="/cadastro" element={<Register />} />
      <Route path="/perfil" element={<ProfileSettings />} />
      <Route
        path="/perfil/editar"
        element={
          <ProtectedRoute>
            <ProfileEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path="/amigos"
        element={
          <ProtectedRoute>
            <Friends />
          </ProtectedRoute>
        }
      />
      <Route
        path="/turmas"
        element={
          <ProtectedRoute>
            <Turmas />
          </ProtectedRoute>
        }
      />
      <Route
        path="/turmas/nova"
        element={
          <ProtectedRoute>
            <CreateTurma />
          </ProtectedRoute>
        }
      />
      <Route
        path="/turmas/:id"
        element={
          <ProtectedRoute>
            <TurmaDetalhe />
          </ProtectedRoute>
        }
      />
      <Route
        path="/turmas/:id/configuracoes"
        element={
          <ProtectedRoute>
            <TurmaSettings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/turmas/:id/convites"
        element={
          <ProtectedRoute>
            <TurmaConvites />
          </ProtectedRoute>
        }
      />
      <Route
        path="/convite/turma/:id"
        element={
          <ProtectedRoute>
            <TurmaInviteLink />
          </ProtectedRoute>
        }
      />
      <Route
        path="/turmas/:id/jogos/novo"
        element={
          <ProtectedRoute>
            <TurmaNovoJogo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/turmas/:id/jogos/:jogoId/pre-jogo"
        element={
          <ProtectedRoute>
            <PreJogo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/turmas/:id/jogos/:jogoId/andamento"
        element={
          <ProtectedRoute>
            <JogoEmAndamento />
          </ProtectedRoute>
        }
      />
      <Route
        path="/turmas/:id/jogos/:jogoId/relatorio"
        element={
          <ProtectedRoute>
            <RelatorioFinal />
          </ProtectedRoute>
        }
      />
      <Route
        path="/turmas/:id/jogos/:jogoId/relatorio/salvo"
        element={
          <ProtectedRoute>
            <TurmaRelatorio />
          </ProtectedRoute>
        }
      />
      <Route
        path="/turmas/:id/estatisticas"
        element={
          <ProtectedRoute>
            <TurmaEstatisticas />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
